<script>
  import { createEventDispatcher } from 'svelte';
  import ProfileImg from './ProfileImage.svelte';
  import { displayTimeAgo } from 'components/Helper.js';
  import { navigate } from 'svelte-routing';
  import ActiveEngagementType from './AddClient/ActiveEngagementType.svelte';
  //let photoUrl = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcL_hveDzFBZFoTZ8qs902bi097hHDNIsfCg&usqp=CAU"
  export let itemData;
  const dispatch = createEventDispatcher();
</script>

<li class="position-relative d-flex align-items-start">
  <!-- <div class="log-type d-flex align-items-center justify-content-center">
		<img alt="" src="/images/login_activity.svg"/>
	</div> -->
  <ProfileImg
    size={40}
    photoUrl={itemData.user.photoUrl}
    firstName={itemData.user.firstName}
    lastName={itemData.user.lastName}
    className="d-inline-block align-middle"
  />
  <div>
    <div class="ms-3">
      <button
        class="border-0 bg-transparent text-left py-0 text-start cursor-none"
        on:click={() => {
          if (itemData.url != null && itemData.url.trim() != '') {
            navigate(itemData.url);
          }
        }}
      >
        <span class="text-break d-inline-block">{itemData.message}</span>
      </button>
    </div>
    {#if itemData.isModalShow}
      <div class="mx-3">
        <button
          class="label view-btn btn-primary label-primary p-1 background-blue rounded text-white border-0 px-2"
          on:click={() => {
            dispatch('handleClick', itemData.id);
          }}
        >
          View</button
        >
      </div>
    {/if}
    <div class="ms-3">
      <button
        class="border-0 bg-transparent text-left py-0 text-start cursor-none"
        on:click={() => {
          if (itemData.url != null && itemData.url.trim() != '') {
            navigate(itemData.url);
          }
        }}
      >
        <span class="text-muted ms-0 d-block text-start">
          <img
            alt=""
            class="me-1 time-icon icon-14"
            src="/images/clock.svg"
          />
          {itemData.timeDisplayTZ}</span
        >
      </button>
    </div>
    {#if itemData.reason != ''}
      <div class="mx-3">
        <span class="badge badge-pill badge-warning text-resason text-break">
          Reason: {itemData.reason}
        </span>
      </div>
    {/if}

    <div></div>
  </div>
</li>

<style lang="scss">
  .text-resason {
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 637px;
  }
  li {
    /* padding-left:40px; */
    margin-bottom: 15px;
    .badge-warning {
      background-color: #f2ecc2;
      color: $black-color;
      font-weight: 400;
      padding: 5px 15px;
      font-size: 12px;
      margin-top: 4px;
    }
  }
  .view-btn {
    margin-top: 4px;
    margin-bottom: 5px;
    margin-left: 5px;
  }
</style>
